import React from "react";
import { ReactComponent as Pinned } from "./pinned.svg";

const General = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>General</b>
      </div>
      <div className="helpDescription">
        <b>General information about the server</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          <Pinned className="pinned"></Pinned>
          <div className="benefitsBoldedText"> Perk System</div>
          <div className="dotBoldedTextSmaller">___</div>
          The kfOne server has a unique Perk Reset system, where player can
          reset their perk, when it reaches a specific level. Doing so, resets
          the perk progress while granting a huge XP and a damage boost.
        </div>
        <div className="listText">
          Perk reset grants:
          <ul>
            <li>XP multiplier;</li>
            <li>Damage boost ( healing potency for Field Medic );</li>
            <li>Additional bonuses;</li>
          </ul>
          Additional bonuses:
          <ul>
            <li>Advanced Ammo Turret on level 1 perk reset;</li>
            <li>Advanced Healing Sentry on level 5 perk reset;</li>
            <li>Character Skin Pack on level 7 perk reset;</li>
            <li>Shield on level 10 perk reset;</li>
          </ul>
          Additional bonuses are shared between perks. Perk resets are available
          every 6 to 8 levels, depending on the perk reset tier.
        </div>
      </div>

      <div className="textBoxSmallerCont">
        <div className="textBoxSmaller">
          <Pinned className="pinned"></Pinned>
          <div className="perkDescr">
            <div className="benefitsBoldedText"> Music System</div>
            <div className="dotBoldedTextSmaller">___</div>
            The in-game music is a big part of the game, therefore we
            implemented a system that cycles all available music, so bigger
            variety of music choices are used than stated in the Map config.
          </div>
        </div>

        <div className="textBoxSmaller">
          <Pinned className="pinned"></Pinned>

          <div className="perkDescr">
            <div className="benefitsBoldedText"> Mutated Zeds</div>
            <div className="dotBoldedTextSmaller">___</div>
            We really liked the N7 Zeds mutator and the whole idea behind it, so
            we made that nearly all the Zeds in the server have a chance to
            "Mutate", which spawns a stronger version of the specific zed.
          </div>
        </div>
      </div>

      <div className="textBox">
        <div className="perkDescr">
          <div className="benefitsBoldedText"> Update 5</div>
          <div className="dotBoldedTextSmaller">___</div>
          <p>Added option to play without registration, as a GUEST;</p>
          <p>Increased ServerMaxTickRate;</p>
          <p>Added GAUSS rifle for Sharpshooter;</p>
          <p>Added PB pistol for Demolitions;</p>
          <p>Added zeds' headshot hitbox fix from SCRN.</p>
          <p>Made VIP free.</p>
          <p>2026/08/02</p>
        </div>
      </div>

      <div className="textBox">
        <div className="perkDescr">
          <div className="benefitsBoldedText"> Update 4</div>
          <div className="dotBoldedTextSmaller">___</div>
          <p>Should be less lag before waves;</p>
          <p>
            Fixed issue where some Commando weapons did not allow buying ammo
            from trader;
          </p>
          <p>Fixed issue that Advanced Med Sentry was not weldable;</p>
          <p>
            Added Crosshair option, which is accessable via ingame menu
            ESC-Client Options. Players can enable/disable the crosshair, change
            size or color.
          </p>
          <p>
            Removed Map description box in the lobby, feels less claustrophobic;
          </p>
          <p>
            Removed Event Server Achievements as it was buggy, added Suicidal,
            HOE map achievements;
          </p>
          <p>2025/09/18</p>
        </div>
      </div>

      <div className="textBox">
        <div className="perkDescr">
          <div className="benefitsBoldedText"> Update 3</div>
          <div className="dotBoldedTextSmaller">___</div>
          <p>Fixed Ammo Turret health increasing above 100%;</p>
          <p>Increased spawn rate of Zeds for waves below 4;</p>
          <p>Significantly increased health of Scrake, Jason and Endy;</p>
          <p>Slightly increased Super Welder recharge rate;</p>
          <p>
            Players with Berserker perk will now make 50% more damage if
            players' health is below 35;
          </p>
          <p>Readjusted Berserkers' Bloat Vomit Damage reduction bonus;</p>
          <p>Readjusted and fixed Supports' Shotgun Penetration bonus;</p>
          <p>
            Players now have ability to change maps' difficulty to Hell on Earth
            or Suicidal via command mutate diff ( default is Hard ); Change can
            be done once per Map and resets on the next map. Change can be made
            only in trader time and all players playing have to vote for the
            change;
          </p>
          <p>2025/09/12</p>
        </div>
      </div>

      <div className="textBox">
        <div className="perkDescr">
          <div className="benefitsBoldedText"> Update 2</div>
          <div className="dotBoldedTextSmaller">___</div>
          <p>Fixed missing hud image for Aluminium Bat</p>
          <p>Increased weapon reach for Gensho sword</p>
          <p>Increased weapon reach for Lightsaber</p>
          <p>Increased amount of starting cash</p>
          <p>Fixed Berreta Alt Fire bug</p>
          <p>Made so dead people can talk</p>
          <p>
            Fixed issue with hud above person showing wrong perk reset level
          </p>
          <p>Various additional bugfixes</p>
          <p>2025/09/07</p>
        </div>
      </div>

      <div className="textBox">
        <div className="perkDescr">
          <div className="benefitsBoldedText"> Update 1</div>
          <div className="dotBoldedTextSmaller">___</div>
          The server was finished and prepared for launch.
          <p>The changelog is not present as it is the first release.</p>
          <p>2025/08</p>
        </div>
      </div>
    </div>
  );
};

export default General;
